import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=54ee02cf&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationPage.vue?vue&type=style&index=0&id=54ee02cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee02cf",
  null
  
)

export default component.exports